import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

//ANT DESIGN IMPORTS
import { Button, Card, Flex, Form, Spin, Steps, Typography } from "antd";

//PROJECT IMPORTS
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";

import dayjs from "dayjs";
import { accountStatus } from "../../../../components/facilities/AccountFacility";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import CustomerEligibilityForm from "./components/CustomerEligibilityForm";
import Preview from "./components/Preview";
import ProductInformationForm from "./components/ProductInformationForm";
import { apiConfig, labelConfig, staticConfig } from "./wallet.config";
import FeedbackModal from "../../../../components/FeedbackModal";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const NewWalletAccount = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { Text, Title } = Typography;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state: selectedBranchKey } = useLocation();

  const [templateProdDetail, setTemplateProdDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [current, setCurrent] = useState(0);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [searchParam, setSearchParam] = useState("");
  const [customerSegmentOptions, setCustomerSegmentOptions] = useState([]);
  const [statementCycleOptions, setStatementCycleOptions] = useState([]);

  // ENDPOINT DECLARED VARIABLES
  const [productData, setProductData] = useState([]);
  const [fieldOfficerData, setFieldOfficerData] = useState([]);
  const [currencyData, setCurrencyData] = useState({});
  const [transactionRestriction, setTransactionRestriction] = useState([]);
  const [kycLevelOptions, setKycLevelOptions] = useState([]);

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    prodInfo: null,
    customerEligibility: null,
  });
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [filteredWalletProduct, setFilteredWalletProduct] = useState([]);

  const stepTitles = ["Product Information", "Customer Eligibility", "Preview"];

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    if (!searchKey) {
      return;
    }

    setSearchParam(searchKey);
  }

  useEffect(() => {
    getWalletAccountTemplate();
  }, []);

  const getCustomerDetailById = (param) => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${param.entityId}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempCurrentCustomer = {
          key: objDetail?.id,
          id: objDetail?.id,
          name: objDetail?.displayName ? objDetail?.displayName : "-",
          clientno: objDetail?.accountNo ? objDetail?.accountNo : "-",
          externalId: objDetail?.externalId ? objDetail?.externalId : "-",
          status: objDetail?.status ? objDetail?.status.value : "-",
          branch: objDetail?.officeName ? objDetail?.officeName : "-",
          staff: objDetail?.staffName ? objDetail?.staffName : "-",
          branchId: objDetail?.officeId ? objDetail?.officeId : "-",
          customerType: objDetail?.legalForm ? objDetail?.legalForm.value : "-",
          agentCode: objDetail?.agentMerchantData
            ? objDetail?.agentMerchantData?.agentCode
            : "-",
          agentType: objDetail?.agentMerchantData
            ? objDetail?.agentMerchantData?.agentType
            : "-",
        };

        setCustomerInfo(tempCurrentCustomer);
        getProductTemplate();
        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };
  const getProductTemplate = () => {
    const url = `${apiConfig.WalletAccount}/template`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        console.log(res);
        let tempProducts = [];

        objList?.walletsProductDataList.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.savingsProductData.name
              ? `${element.savingsProductData.name} (${element.id})`
              : "",
          });
        });

        setProductData(tempProducts);
      }
    });
  };

  const getWalletAccountTemplate = (customerParam) => {
    const url = `${apiConfig.WalletAccount}/template`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempProducts = [];
        console.log(res);

        objList?.productOptions
          ?.filter((item) => item.allowOverdraft === false)
          .forEach((element) => {
            tempProducts.push({
              value: element.id,
              label: element.name ? `${element.name} (${element.id})` : "",
            });
          });

        setProductData(tempProducts);
        setCustomerInfo(customerParam);
      }
    });
  };

  const onChangeProduct = (productParam) => {
    const params = {
      clientId: customerInfo.entityId,
      productId: productParam,
    };

    const url = `${apiConfig.WalletAccount}/template`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        console.log(res);
        setTemplateProdDetail(res);
        const objList = res.walletsProductDataList.find(
          (data) => data.id === productParam,
        );
        const optionList = res;
        // const objList = res;
        console.log(objList);
        let tempProducts = [];
        let tempFieldOfficer = [];
        let tempCurrency = objList?.currency;
        let tempCustomerSegmentOptions = [];
        let temptransactionRestriction = [];
        let tempStatementCycleOptions = [];
        let tempKycOptions = [];

        // console.log(objList);

        useForm.setFieldsValue({
          currencyName: `${objList?.savingsProductData.currency?.name} (${objList?.savingsProductData?.currency?.displaySymbol})`,
          decimalPlaces: objList?.savingsProductData.currency?.decimalPlaces,
          inMultiplesOf: objList?.savingsProductData.currency?.inMultiplesOf,
          kycLevel: objList?.kycLevel,
          customerSegment: objList?.customerSegments?.map((seg) => seg.id),
          transactionRestriction: objList?.transactionRestrictions?.map(
            (seg) => seg.id,
          ),
          statementCycle: objList?.statementCycles?.map((seg) => seg.id),
          submittedOnDate: dayjs(),
          nominalAnnualInterestRate: objList?.nominalAnnualInterestRate,
          interestCompoundingPeriodType:
            objList?.interestCompoundingPeriodType?.id,
          interestPostingPeriodType: objList?.interestPostingPeriodType?.id,
          interestCalculationType: objList?.interestCalculationType?.id,
          interestCalculationDaysInYearType:
            objList?.interestCalculationDaysInYearType?.id,
          minRequiredOpeningBalance: objList?.minRequiredOpeningBalance,
          lockinPeriodFrequency: objList?.lockinPeriodFrequency,
          lockinPeriodFrequencyType: objList?.lockinPeriodFrequencyType?.id,
        });

        res?.walletsProductData.customerSegmentTypes?.forEach((element) => {
          tempCustomerSegmentOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        res?.walletsProductData.transactionRestrictionTypes?.forEach(
          (element) => {
            temptransactionRestriction.push({
              value: element.id,
              label: element.value,
            });
          },
        );

        res?.walletsProductData.statementCycleTypes?.forEach((element) => {
          tempStatementCycleOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        res?.walletsProductData?.kycLevelTypes?.forEach((element) => {
          tempKycOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.fieldOfficerOptions?.forEach((element) => {
          tempFieldOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });

        // setProductData(tempProducts);
        setFieldOfficerData(tempFieldOfficer);
        setCurrencyData(tempCurrency);
        setKycLevelOptions(tempKycOptions);
        setCustomerSegmentOptions(tempCustomerSegmentOptions);
        setTransactionRestriction(temptransactionRestriction);
        setStatementCycleOptions(tempStatementCycleOptions);
        setIsProductSelected(true);
        setFilteredWalletProduct(objList);
        setIsLoading(false);
      }
    });
  };

  const onSearch = () => {
    setIsProductSelected(false);
    useForm.resetFields();

    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }
    const params = {
      exactMatch: true,
      query: searchParam.trim(),
      resource: "clients,clientIdentifiers",
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Search, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempCustomer = [];

        objList
          ?.filter((item) => item?.entityCode === searchParam)
          .forEach((element) => {
            tempCustomer.push({
              label: `${element.entityName || ""} - ${
                element.entityMobileNo || ""
              }`,
              value: element.entityId || "",
              entityAccountNo: element.entityAccountNo || "",
              entityId: element.entityId || "",
              entityMobileNo: element.entityMobileNo || "",
              entityName: element.entityName || "",
              entityType: element.customerType || "",
              entityCode: element.entityCode || "",
            });
          });

        if (tempCustomer[0] === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching Agent found.");
          setShowDetailsForm(false);
          setIsLoading(false);
          return;
        }

        getCustomerDetailById(tempCustomer[0]);
      }
    });
  };

  const onChange = (value) => {
    setCurrent(value);
  };

  const onFinishProdInfoForm = (values) => {
    console.log(values);

    values.submittedOnDate = values.submittedOnDate
      ? BOM.DateTime(values.submittedOnDate, "only-date")
      : values.submittedOnDate;
    setFormData({ ...formData, prodInfo: values });

    setCurrent(current + 1);
  };

  const onFinishCustomerEligibilityForm = (values) => {
    console.log(values);

    setFormData({ ...formData, customerEligibility: values });
    setCurrent(current + 1);
  };

  const forms = [
    <ProductInformationForm
      onSearch={onSearch}
      searchParam={searchParam}
      customerInfo={customerInfo}
      showDetailsForm={showDetailsForm}
      onFinish={onFinishProdInfoForm}
      form={useForm}
      currencyData={currencyData}
      initialValues={formData.prodInfo}
      onChangeProduct={onChangeProduct}
      productData={productData}
      fieldOfficerData={fieldOfficerData}
      handleSearchInTable={handleSearchInTable}
      isProductSelected={isProductSelected}
      transactionRestriction={transactionRestriction}
      customerSegmentOptions={customerSegmentOptions}
      statementCycleOptions={statementCycleOptions}
      isCreateScreen={true}
      userData={userData}
    />,

    <CustomerEligibilityForm
      onFinish={onFinishCustomerEligibilityForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.customerEligibility}
      form={useForm}
      transactionRestriction={transactionRestriction}
      customerSegmentOptions={customerSegmentOptions}
      statementCycleOptions={statementCycleOptions}
      kycLevelOptions={kycLevelOptions}
    />,

    <Preview
      formData={formData}
      // useCases={useCases}
      customerSegmentOptions={customerSegmentOptions}
      transactionRestriction={transactionRestriction}
      statementCycleOptions={statementCycleOptions}
      currencyData={currencyData}
      customerInfo={customerInfo}
      templateProdDetail={templateProdDetail}
      productData={productData}
      filteredWalletProduct={filteredWalletProduct}
      kycLevelOption={kycLevelOptions}
    />,
  ];

  function onCancel() {
    navigate("/wallet-account", { replace: false });
  }
  const isLastStep = current === forms.length - 1;

  const nextButtonClick = () => {
    useForm.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  const onSubmit = (formValues) => {
    formValues = {
      ...formData.prodInfo,
      ...formData.customerEligibility,
    };

    console.log(customerInfo);

    // CHARGES STICT VALUES
    formValues.clientId = customerInfo.id;
    formValues.dateFormat = "dd MMMM yyyy";
    formValues.locale = "en";

    delete formValues.currencyName;
    delete formValues.decimalPlaces;
    delete formValues.inMultiplesOf;
    delete formValues.customerSearch;
    delete formValues.initiatedBy;

    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    console.log(body);
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.WalletAccount,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newSavingsAccountMsg);
          navigate("/wallet-account", {
            state: {
              id: res.resourceId,
              statusValue: accountStatus.submittedAndPending,
            },
          });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/wallet-account");
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout
      pageItems={staticConfig.newWalletAccountBreadcrumbItems}
      onSave={onSubmit}
    >
      <TopContent
        pageTitle={labelConfig.newWalletAccount}
        createPageTitle={labelConfig.createWalletAccount}
      />
      <Spin spinning={isLoading} size="large">
        <div
          style={{
            display: "flex",
            paddingLeft: "44px",
            marginTop: "20px",
            widtth: "100%",
          }}
        >
          {/* Navigation section */}
          <div style={{ width: "288px", padding: "20px 0" }}>
            <Steps
              className="custom-step-style"
              current={current}
              onChange={onChange}
              direction="vertical"
              style={{ height: "723px" }}
              items={[
                {
                  title: <Text strong>Product Information</Text>,
                  disabled: !isProductSelected,
                },
                {
                  title: <Text strong>Customer Eligibility</Text>,
                  disabled: !isProductSelected,
                },
                {
                  title: <Text strong>Preview</Text>,
                  disabled: !isProductSelected,
                },
              ]}
            />
          </div>

          {/* Form section */}
          <Card
            style={{
              borderRadius: 20,
              width: "100%",
              margin: 0,
              display: "flex",
              flexDirection: "column",
              padding: "0 20px",
              height: `${current === forms.length - 1 ? "723px" : "100%"}`,
              overflowY: `${current === forms.length - 1 ? "auto" : "hidden"}`,
            }}
          >
            <div style={{ flexGrow: 1 }}>{forms[current]}</div>

            {/* Button Section (at bottom) */}
            <div
              style={{
                paddingTop: 30,
                borderRadius: 20,
              }}
            >
              <Flex justify="end" gap="30px" align="end">
                {current === 0 && (
                  <Button
                    style={{
                      backgroundColor: "white",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    colortext="#344054"
                    className="previous-button"
                    onClick={onCancel}
                  >
                    Go Back
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      backgroundColor: "white",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    colortext="#344054"
                    className="previous-button"
                    onClick={prevButtonClick}
                  >
                    Previous
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      backgroundColor: "#BA24D5",
                      color: "white",
                      border: "1px solid #BA24D5",
                      borderRadius: 8,
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    onClick={nextButtonClick}
                  >
                    Next - {stepTitles[current + 1]}
                  </Button>
                )}
                {BOM.HasPermission("CREATE_BOND") && isLastStep && (
                  <Button
                    style={{
                      backgroundColor: "#BA24D5",
                      color: "white",
                      border: "1px solid #BA24D5",
                      borderRadius: 8,
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    onClick={onSubmit}
                  >
                    {selectedBranchKey ? "Edit Account" : "Create Account"}
                  </Button>
                )}
              </Flex>
            </div>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NewWalletAccount);
